import { render, staticRenderFns } from "./StickerCta.vue?vue&type=template&id=f80db62e"
import script from "./StickerCta.vue?vue&type=script&lang=js"
export * from "./StickerCta.vue?vue&type=script&lang=js"
import style0 from "./StickerCta.vue?vue&type=style&index=0&id=f80db62e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports